export type FieldErrors = Record<string, string[]>;

export interface ProblemDetails {
  title?: string;
  detail?: string;
  status?: number;
  code?: string;
  traceId?: string;
  errors?: FieldErrors;
}

export class ApiProblem extends Error {
  readonly status: number;
  readonly code?: string;
  readonly traceId?: string;
  readonly errors?: FieldErrors;

  constructor(problem: ProblemDetails, fallbackStatus: number) {
    super(problem.detail ?? problem.title ?? `Request failed with HTTP ${fallbackStatus}.`);
    this.name = "ApiProblem";
    this.status = problem.status ?? fallbackStatus;
    this.code = problem.code;
    this.traceId = problem.traceId;
    this.errors = problem.errors;
  }

  get isSessionExpired(): boolean {
    return this.status === 401;
  }

  get isForbidden(): boolean {
    return this.status === 403;
  }

  get isStale(): boolean {
    return this.status === 412;
  }
}

export function isApiProblem(value: unknown): value is ApiProblem {
  return value instanceof ApiProblem;
}

export function formatProblem(problem: ApiProblem): string {
  const validation = problem.errors
    ? Object.values(problem.errors).flat().filter(Boolean).join(" ")
    : undefined;
  return validation || problem.message;
}
